import clsx from 'clsx'
import { GetStaticProps, GetStaticPropsContext } from 'next'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from '../container/Layout'
import styles from '../styles/imprint.module.scss'

interface Props {
	locale: string
}

export default function Imprint({ locale }: Props): JSX.Element {
	const meta = {
		title: [{ text: 'Get in touch  – FUCHSFOX', type: '' }],
		description: [{ text: 'By phone We are just a call away, every day of the week +45 89 87 09 43', type: '' }],
		keyword: ['Contact', 'Get in touch', 'fuchs', 'fox', 'phone', 'FUCHSFOX', 'fuchsfox'],
		robot: 'no-index',
	}
	const { t } = useTranslation(['imprint', 'contact'])
	return (
		<Layout>
			<div className="inner">
				<section className={styles.section}>
					<div className={clsx(styles.header)}>
						<h1 className={styles.title}>{t('imprint:title')}</h1>
						<h2>{t('imprint:information')}:</h2>
					</div>
				</section>
				<section className={styles.section}>
					<article className={clsx(styles.contact)}>
						<p>
							<strong>{t('contact:email')}:</strong>
							<br />
							<a className={styles.link} href="mailto:hello@fuchsfox.com">
								hello@fuchsfox.com
							</a>
						</p>
						<p>
							<strong>{t('contact:mobile')}:</strong>
							<br />
							<a className={styles.link} href="tel:+4915209001910">
								+49 152 0900 1910
							</a>
						</p>
					</article>
					<article className={clsx(styles.contact)}>
						<p>
							<strong>{t('imprint:address')}</strong>
							<br />
							FUCHSFOX GbR <br />
							Bismarckstraße 88 <br />
							20253 Hamburg <br />
							{t('contact:country')}
						</p>
						<p>
							<strong>{t('imprint:represented')}</strong>
							<br />
							Niklas Fuchs <br />
							Justin Fox
						</p>
					</article>
				</section>
				<section className={styles.section}>
					<article className={clsx(styles.disclaimer)}>
						<h4>{locale === 'de' ? 'Haftungsausschluss' : 'Legal notice'}</h4>
						<p>
							{locale === 'de'
								? 'Jede auszugsweise oder gewerbliche Nutzung bedarf der vorherigen schriftlichen Genehmigung der FUCHSFOX GbR'
								: 'Any partial or commercial use requires the prior written consent of FUCHSFOX GbR'}
						</p>
						<h4>{t('imprint:contents.title')}</h4>
						<p>{t('imprint:copyright.paragraph')}</p>
						<h4>{t('imprint:links.title')}</h4>
						<p>{t('imprint:copyright.paragraph')}</p>
						<h4>{t('imprint:copyright.title')}</h4>
						<p>{t('imprint:copyright.paragraph')}</p>
						<h4>{t('imprint:social')}</h4>
						<p>
							Facebook (https://www.facebook.com/followfuchsfox) <br />
							Twitter (https://twitter.com/followfuchsfox) <br />
							Instagram (https://www.instagram.com/followfuchsfox)
						</p>
						<p>
							{locale === 'de' ? 'Fotos' : 'Images'} <span> {locale === 'de' ? 'Private' : 'Private'}</span>
						</p>
					</article>
				</section>
			</div>
		</Layout>
	)
}

export const getStaticProps: GetStaticProps = async ({ locale }: GetStaticPropsContext) => {
	return {
		props: {
			locale,
		},
	}
}
